import { LayoutContainer } from '@petsmart-ui/sparky';

import type { DropdownNavigationItem } from '../../../../types';
import { PanelBody } from './panel-body';
import { SidebarPanel } from './sidebar-panel';

type DropdownPanelProps = {
    item: DropdownNavigationItem;
};

export function DropdownPanel({ item }: DropdownPanelProps) {
    const selectionPath = [item.title];

    return (
        <LayoutContainer className="dropdown-panel sparky-u-width-100">
            {item.kind === 'sidebar' ? (
                <SidebarPanel items={item.sidebarItems} selectionPath={selectionPath} />
            ) : (
                <PanelBody panel={item.panel} selectionPath={selectionPath} />
            )}
        </LayoutContainer>
    );
}
